module.exports = __webpack_public_path__ + "static/media/16UNODC30.4a9d59a1.jpg";